export enum PolicyStatuses {
  active = 'Active',
  pending = 'Pending',
  expired = 'Expired',
}
